import * as yup from "yup";

export const userSchema = yup.object({
  firstName: yup
    .string()
    .required("First Name is required")
    .test(
      'no-only-spaces',
      'First Name cannot contain only spaces',
      function(value) {
        if (!value) return false;
        return value.trim().length > 0;
      }
    )
    .test(
      'no-special-characters',
      'First Name cannot contain special characters',
      function(value) {
        if (!value) return true;
        // Allow only letters and spaces
        return /^[a-zA-Z\s]+$/.test(value);
      }
    )
    .test(
      'valid-name',
      'First Name must contain at least one letter',
      function(value) {
        if (!value) return true;
        // Ensure at least one letter exists
        return /[a-zA-Z]/.test(value);
      }
    ),
  lastName: yup
    .string()
    .test(
      'no-only-spaces',
      'Last Name cannot contain only spaces',
      function(value) {
        // If no value, it's valid (optional field)
        if (!value || value === '') return true;
        return value.trim().length > 0;
      }
    )
    .test(
      'no-special-characters',
      'Last Name cannot contain special characters',
      function(value) {
        if (!value || value === '') return true;
        // Allow only letters and spaces
        return /^[a-zA-Z\s]+$/.test(value);
      }
    )
    .test(
      'valid-name',
      'Last Name must contain at least one letter',
      function(value) {
        if (!value || value === '') return true;
        // Ensure at least one letter exists
        return /[a-zA-Z]/.test(value);
      }
    ),
  designation: yup
    .string()
    .nullable()
    .optional()
    .test(
      'no-only-spaces',
      'Designation cannot contain only spaces',
      function (value) {
        if (!value || value === '') return true;
        return value.trim().length > 0;
      }
    )
    .max(255, 'Designation cannot exceed 255 characters'),
  customDesignation: yup
    .string()
    .nullable()
    .when('designation', {
      is: '__other__',
      then: (schema) =>
        schema
          .required('Please enter a custom designation')
          .test(
            'no-only-spaces',
            'Custom designation cannot contain only spaces',
            function (value) {
              if (!value) return false;
              return value.trim().length > 0;
            }
          )
          .max(255, 'Custom designation cannot exceed 255 characters'),
      otherwise: (schema) => schema.optional(),
    }),
  phoneNumber: yup
    .string()
    .nullable()
    .optional()
    .test(
      'no-only-spaces',
      'Phone number cannot contain only spaces',
      function(value) {
        // If no value provided, it's valid (optional field)
        if (!value || value === '') return true;
        // If value provided, ensure it's not just spaces
        return value.trim().length > 0;
      }
    )
    .test(
      'phone-validation',
      'Phone number can only contain digits, +, -, (), and spaces',
      function(value) {
        // If no value provided, it's valid (optional field)
        if (!value || value.trim() === '') return true;
        // Allow +, digits, spaces, hyphens, and parentheses
        return /^[\d\s\+\-\(\)]+$/.test(value);
      }
    )
    .test(
      'phone-format',
      'Please enter a valid Indian mobile number (exactly 10 digits starting with 6, 7, 8, or 9)',
      function(value) {
        // If no value provided, it's valid (optional field)
        if (!value || value.trim() === '') return true;
        // Remove all non-digit characters
        const digitsOnly = value.replace(/\D/g, '');
        // Must have exactly 10 digits and start with 6, 7, 8, or 9
        return digitsOnly.length === 10 && /^[6-9]/.test(digitsOnly);
      }
    ),
  username: yup
    .string()
    .email("Email must be a valid email")
    .required("Email is required"),
  password: yup
    .string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/\d/, "Password must contain at least one number")
    .matches(
      /[!@#$%^&*(),.?":{}|<>]/,
      "Password must contain at least one special character"
    ),
  roleType: yup.string().required("Role Type is required"),
});

export const updateUserSchema = yup.object({
  firstName: yup
    .string()
    .required("First Name is required")
    .test(
      'no-only-spaces',
      'First Name cannot contain only spaces',
      function(value) {
        if (!value) return false;
        return value.trim().length > 0;
      }
    )
    .test(
      'no-special-characters',
      'First Name cannot contain special characters',
      function(value) {
        if (!value) return true;
        // Allow only letters and spaces
        return /^[a-zA-Z\s]+$/.test(value);
      }
    )
    .test(
      'valid-name',
      'First Name must contain at least one letter',
      function(value) {
        if (!value) return true;
        // Ensure at least one letter exists
        return /[a-zA-Z]/.test(value);
      }
    ),
  lastName: yup
    .string()
    .test(
      'no-only-spaces',
      'Last Name cannot contain only spaces',
      function(value) {
        // If no value, it's valid (optional field)
        if (!value || value === '') return true;
        return value.trim().length > 0;
      }
    )
    .test(
      'no-special-characters',
      'Last Name cannot contain special characters',
      function(value) {
        if (!value || value === '') return true;
        // Allow only letters and spaces
        return /^[a-zA-Z\s]+$/.test(value);
      }
    )
    .test(
      'valid-name',
      'Last Name must contain at least one letter',
      function(value) {
        if (!value || value === '') return true;
        // Ensure at least one letter exists
        return /[a-zA-Z]/.test(value);
      }
    ),
  designation: yup
    .string()
    .nullable()
    .optional()
    .test(
      'no-only-spaces',
      'Designation cannot contain only spaces',
      function (value) {
        if (!value || value === '') return true;
        return value.trim().length > 0;
      }
    )
    .max(255, 'Designation cannot exceed 255 characters'),
  customDesignation: yup
    .string()
    .nullable()
    .when('designation', {
      is: '__other__',
      then: (schema) =>
        schema
          .required('Please enter a custom designation')
          .test(
            'no-only-spaces',
            'Custom designation cannot contain only spaces',
            function (value) {
              if (!value) return false;
              return value.trim().length > 0;
            }
          )
          .max(255, 'Custom designation cannot exceed 255 characters'),
      otherwise: (schema) => schema.optional(),
    }),
  phoneNumber: yup
    .string()
    .nullable()
    .optional()
    .test(
      'no-only-spaces',
      'Phone number cannot contain only spaces',
      function(value) {
        // If no value provided, it's valid (optional field)
        if (!value || value === '') return true;
        // If value provided, ensure it's not just spaces
        return value.trim().length > 0;
      }
    )
    .test(
      'phone-validation',
      'Phone number can only contain digits, +, -, (), and spaces',
      function(value) {
        // If no value provided, it's valid (optional field)
        if (!value || value.trim() === '') return true;
        // Allow +, digits, spaces, hyphens, and parentheses
        return /^[\d\s\+\-\(\)]+$/.test(value);
      }
    )
    .test(
      'phone-format',
      'Phone number must be exactly 10 digits',
      function(value) {
        // If no value provided, it's valid (optional field)
        if (!value || value.trim() === '') return true;
        // Remove all non-digit characters
        const digitsOnly = value.replace(/[^\d]/g, '');
        // Must have exactly 10 digits
        return digitsOnly.length === 10;
      }
    ),
  username: yup
    .string()
    .email("Email must be a valid email")
    .required("Email is required"),
});
